import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Toggle from 'react-toggle';
import Select from 'react-select';
import moment from 'moment';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import API from '../../../utils/API';
import DeleteDefaultModal from './modals/deleteDefaultModal';
import BasicSectionHeader from '../../../components/views/BasicSectionHeader';
import InputField from '../../../components/inputs/inputField';
import SelectField from '../../../components/inputs/selectField';
import ToggleField from '../../../components/inputs/toggleField';
import TextAreaField from '../../../components/inputs/textAreaField';
import TimeField from '../../../components/inputs/timeField';
import SectionHeader from '../../../components/views/SectionHeader';
import SectionFooter from '../../../components/views/SectionFooter';
import VenuesLocationField from '../../../components/venues/venuesLocationField'

const virtualMeetingTypes = [
	{ label: 'Stream', value: 'stream' },
	{ label: 'Meeting', value: 'meeting' },
	{ label: 'In-Person', value: 'in-person' },
	{ label: 'Link', value: 'link' },
	{ label: 'Break', value: 'break' },
	{ label: 'Webinar', value: 'webinar' }
];
class EventSession extends Component {
	constructor(props) {
		super(props);
		const { match: { params } } = this.props;
		const session = props.sessions.find((s) => s._id == params.sessionId);
		this.props.setActiveRow(params.sessionId)
		this.state = {
			session: session,
			editedSession: { ...session },
			customFields: {},
			selectedSection: 0,
			DeleteSessionModalOpen: false,
			loading: true,
			editing: false,
			requiredFields: {
				name: false,
				startTime: false,
				endTime: false
			},
			locationOptions: props.locations,
			
		};
	}
	componentWillUnmount() {
		this.props.setActiveRow(null);
	}

	saveInfo = () => {
		const { editedSession } = this.state;
		const requiredFields = this.state.requiredFields;
		let valid = true;

		Object.keys(requiredFields).forEach((key) => {
			if (!editedSession[key] || editedSession[key] === '') {
				if (key === 'startTime' && editedSession.isAllDay) {
					return;
				} else if (key === 'endTime' && editedSession.isAllDay) {
					return;
				}
				requiredFields[key] = true;
				valid = false;
			} else {
				requiredFields[key] = false;
			}
		});

		if (valid) {
			const today = moment().format('YYYY-MM-DD');
			if (!editedSession.isAllDay) {
				editedSession.startTime = moment(`${today} ${editedSession.startTime}`).format('hh:mm a');
				editedSession.endTime = moment(`${today} ${editedSession.endTime}`).format('hh:mm a');
			} else {
				editedSession.startTime = '';
				editedSession.endTime = '';
			}
			this.props.saveSession(editedSession, () => {
				this.setState({ session: { ...editedSession }, editing: false, requiredFields: requiredFields });
			});
		} else {
			this.setState({ requiredFields: requiredFields });
		}
	};

	toggleDelete = () => {
		this.setState({ DeleteSessionModalOpen: !this.state.DeleteSessionModalOpen });
	};

	toggleEditing = (bool) => {
		this.setState({ editing: bool });
	};

	editSessionField = (property, value) => {
		const editedSession = this.state.editedSession;
		editedSession[property] = value;
		this.setState({ editedSession: editedSession, editing: true });
	};

	editTravelFields = (data) => {
		this.setState({ editedSession: data });
	};

	editRoomingFields = (data) => {
		this.setState({ editedSession: data });
	};

	updateCustomField = (e, meta, categoryId) => {
		const customFields = this.state.customFields;
		meta.fieldType === 'checkbox'
			? (customFields[categoryId][meta._id].value = e.target.checked)
			: (customFields[categoryId][meta._id].value = e.target.value);

		this.setState({ customFields: customFields, editing: true });
	};

	cancelEdit = () => {
		const session = this.state.session;
		const fields = {};
		const requiredFields = this.state.requiredFields;
		Object.keys(requiredFields).forEach((key) => {
			requiredFields[key] = false;
		});
		this.setState({
			editedSession: { ...session },
			requiredFields: requiredFields,
			editing: false,
			customFields: fields
		});
	};

	render() {
		const { DeleteSessionModalOpen, loading, editing, session, editedSession, requiredFields } = this.state;
		const { match: { params }, program } = this.props;
		const sessionLocationId = editedSession.location ? editedSession.location : '';
	//	selectedVenue={this.props.venues.find(v => v._id == this.props.event.venue) || ''}

		return (
			<div className="sectionContainer">
				<SectionHeader
					title={`${session.name}`}
					titleIcon={<div className="calibreBold fs-30">{session.name.toUpperCase().charAt(0)}</div>}
					closeButton={true}
					enableLastLink={true}
					subActions={[{ onClick: this.toggleDelete, label: <span><i className='las la-trash mr-10'></i>Delete Session</span> }]}
				/* breadcrumbs={[
					{
						name: program.name
					},
					{
						name: 'Event Sessions'
					}
				]} */
				/>
				<div className="sectionBody">
					<div className="sectionBlock">
						<InputField
							label="Session Name"
							required={true}
							errorTrigger={requiredFields.name}
							value={editedSession.name}
							type="text"
							onChange={(e) => this.editSessionField('name', e.target.value)}
						/>
						<SelectField
							label="Session Type"
							value={virtualMeetingTypes.find((vmt) => vmt.value == editedSession.virtualMeetingType)}
							name="Session type"
							options={virtualMeetingTypes}
							onChange={(vmt) => this.editSessionField('virtualMeetingType', vmt.value)}
						/>
						<InputField
							label="Subtitle"
							value={editedSession.subtitle}
							type="text"
							onChange={(e) => this.editSessionField('subtitle', e.target.value)}
						/>
						<InputField
							label="Description"
							value={editedSession.description}
							type="text"
							onChange={(e) => this.editSessionField('description', e.target.value)}
						/>

						<ToggleField
							label="Is All Day"
							checked={editedSession.isAllDay}
							icons={false}
							onChange={(e) => this.editSessionField('isAllDay', !editedSession.isAllDay)}
						/>
						{!editedSession.isAllDay && (
							<div className="flex-sb">
								<TimeField
									label={'Start Time'}
									onChange={(time) => this.editSessionField('startTime', time)}
									value={editedSession.startTime}
									classes="mr-10 w-100"
									required={true}
									errorTrigger={requiredFields.startTime}
								/>
								<TimeField
									label={'End Time'}
									onChange={(time) => this.editSessionField('endTime', time)}
									value={editedSession.endTime}
									classes="ml-10 w-100"
									required={true}
									errorTrigger={requiredFields.endTime}
								/>
							</div>
						)}
						<ToggleField
							label="Is General"
							checked={editedSession.isGeneral}
							icons={false}
							onChange={(e) => this.editSessionField('isGeneral', !editedSession.isGeneral)}
						/>
					
						{/* <InputField
							label="Location"
							value={editedSession.location}
							type="text"
							onChange={(e) => this.editSessionField('location', e.target.value)}
						/> */}
					
					<VenuesLocationField
					selectedVenue={this.props.venues.find(v => v._id == this.props.event.details.venue) || ''}
					orgId={this.props.orgId}
					venueOptions={this.props.venues}
					sessionLocationId={editedSession.location}
					isLocation={true}
					selectVenue={(venue) => {
						this.setState({
							venue: {
								value: venue._id,
								label: venue.name,
								color: '#000'
							},
							editing: true
						})
					}}
					venuePicked={this.state.venue}
					selectLocation={(location) => {
						this.editSessionField('location', location._id);
					}}
					addNewLocation={this.props.addNewLocation}
					renameLocation={this.props.renameLocation}
					deleteLocation={(venueId, locationId) => {
						let tempSession = this.state.session;
						if (tempSession.location == locationId) {
							tempSession.location = '';
						}
						let tempEditedSession = this.state.editedSession;
						if (tempSession.location == locationId) {
							tempEditedSession.location = '';

						}
						this.setState({ session: tempSession, editedSession: tempEditedSession });

						this.props.deleteLocation(venueId, locationId);
					}}
				></VenuesLocationField>

						<h3 className='blockHeader'>Onsite Details</h3>

						<div className="flex-sb w-100">
							<InputField
								label={'Set (people)'}
								classes="mr-10 w-100"
								value={editedSession.setPeople}
								type="number"
								min={0}
								onChange={(e) => {
									this.editSessionField('setPeople', e.target.value === '' ? 0 : e.target.value);
								}}
							/>

							<InputField
								label={'Guarantee (people)'}
								classes="ml-10 w-100"
								value={editedSession.guaranteedPeople}
								type="number"
								min={0}
								onChange={(e) => {
									this.editSessionField('guaranteedPeople', e.target.value === '' ? 0 : e.target.value);
								}}
							/>
						</div>

						<div className="flex-sb w-100">
							<TimeField
								label="Set Time"
								value={editedSession.setTime}
								classes="mr-10 w-100"
								onChange={(time) => {
									this.editSessionField('setTime', time);
								}}
							/>
							<TimeField
								label="Strike Time"
								value={editedSession.strikeTime}
								classes="ml-10 w-100"
								onChange={(time) => {
									this.editSessionField('strikeTime', time);
								}}
							/>
						</div>

						<TextAreaField
							label={"Room Set"}
							value={editedSession.roomSet}
							onChange={(e) => {
								this.editSessionField('roomSet', e.target.value);
							}}
						/>
						<InputField
							label="BEO Number"
							value={editedSession.beoNumber}
							type="text"
							onChange={(e) => this.editSessionField('beoNumber', e.target.value)}
						/>
						<TextAreaField
							label={"Food and Beverage"}
							value={editedSession.foodAndBeverage}
							onChange={(e) => {
								this.editSessionField('foodAndBeverage', e.target.value);
							}}
						/>

						<TextAreaField
							label="Hotel Items Needed"
							value={editedSession.hotelItemsNeeded}
							type="text"
							onChange={(e) => this.editSessionField('hotelItemsNeeded', e.target.value)}
						/>

						<TextAreaField
							label="AV Order"
							value={editedSession.avOrder}
							type="text"
							onChange={(e) => this.editSessionField('avOrder', e.target.value)}
						/>

						<TextAreaField
							label="Notes"
							value={editedSession.notes}
							type="text"
							onChange={(e) => this.editSessionField('notes', e.target.value)}
						/>

						<ToggleField
							label={"Posted on Hotel Agenda"}
							checked={editedSession.posted}
							icons={false}
							onChange={(e) => this.editSessionField('posted', !editedSession.posted)}
						/>

						<h3 className='blockHeader'>Website</h3>

						<InputField
							label={'Livestream Link'}
							value={editedSession.virtualMeetingLink}
							type="text"
							onChange={(e) => this.editSessionField('virtualMeetingLink', e.target.value)}
						/>

						<InputField
							label={'Recording Link'}
							value={editedSession.recordingLink}
							type="text"
							onChange={(e) => this.editSessionField('recordingLink', e.target.value)}
						/>

						<label className="displayLabel">
							<div className="flex-ac">
								Back up Session Links
								<div
									onClick={() => {
										if (!editedSession.backupVirtualMeetingLinks || !editedSession.backupVirtualMeetingLinks.includes('') || editedSession.backupVirtualMeetingLinks.length == 0) {
											this.editSessionField('backupVirtualMeetingLinks', editedSession.backupVirtualMeetingLinks ? [...editedSession.backupVirtualMeetingLinks, ''] : [''])
										}
									}}
								>
									<i className="las la-plus-circle ml-10 c-pointer clickable" />
								</div>
							</div>
						</label>

						{editedSession.backupVirtualMeetingLinks && editedSession.backupVirtualMeetingLinks.map((link, index) => {
							return (
								<div style={{ display: 'flex', justifyContent: 'space-between' }} key={index}>
									<div
										onClick={() => {
											editedSession.backupVirtualMeetingLinks.splice(index, 1);
											this.editSessionField('backupVirtualMeetingLinks', editedSession.backupVirtualMeetingLinks);
										}}
									>
										<i className="las la-minus-circle mr-10 c-pointer" style={{ color: 'red' }} />
									</div>
									<InputField
										label="Back up Session Link"
										value={editedSession.backupVirtualMeetingLinks[index]}
										onChange={(e) => {
											let backuplist = JSON.parse(JSON.stringify(editedSession.backupVirtualMeetingLinks));
											backuplist[index] = e.target.value;
											this.editSessionField('backupVirtualMeetingLinks', backuplist);
										}}
									/>
								</div>
							);
						})}

						<ToggleField
							label="Show only survey"
							checked={editedSession.surveyOnly}
							icons={false}
							onChange={(e) => this.editSessionField('surveyOnly', !editedSession.surveyOnly)}
						/>

						<div className="flex-sb w-100">
							<InputField
								label={'Display Start Time'}
								value={editedSession.displayStartTime}
								type="text"
								classes="mr-10 w-100"
								onChange={(e) => this.editSessionField('displayStartTime', e.target.value)}
							/>

							<InputField
								label={'Display End Time'}
								value={editedSession.displayEndTime}
								type="text"
								classes="ml-10 w-100"
								onChange={(e) => this.editSessionField('displayEndTime', e.target.value)}
							/>
						</div>

						<div className="flex-sb w-100">
							<InputField
								label={'Start Offset'}
								value={editedSession.virtualStartOffset}
								type="text"
								classes="mr-10 w-100"
								onChange={(e) => this.editSessionField('virtualStartOffset', e.target.value)}
							/>

							<InputField
								label={'Stop Offset'}
								value={editedSession.virtualStopOffset}
								type="text"
								classes="ml-10 w-100"
								onChange={(e) => this.editSessionField('virtualStopOffset', e.target.value)}
							/>
						</div>

						<InputField
							label={'Display Timezone'}
							value={editedSession.displayTimezone}
							type="text"
							onChange={(e) => this.editSessionField('displayTimezone', e.target.value)}
						/>

						<h4 className='blockHeader'>Features</h4>

						<ToggleField
							label="Enable Session Review"
							checked={editedSession.enableReview}
							icons={false}
							onChange={(e) => this.editSessionField('enableReview', !editedSession.enableReview)}
						/>

						<ToggleField
							label="Enable Survey"
							checked={editedSession.enableSurvey}
							icons={false}
							onChange={(e) => this.editSessionField('enableSurvey', !editedSession.enableSurvey)}
						/>

						{editedSession.virtualMeetingType == 'stream' && (
							<div>
								<ToggleField
									label="Enable Chat"
									checked={editedSession.chatEnabled}
									icons={false}
									onChange={(e) => this.editSessionField('chatEnabled', !editedSession.chatEnabled)}
								/>

								<ToggleField
									label={'Enable Stream Reactions'}
									checked={editedSession.reactionsEnabled}
									icons={false}
									onChange={(e) =>
										this.editSessionField('reactionsEnabled', !editedSession.reactionsEnabled)}
								/>

								<ToggleField
									label="Enable Polls"
									checked={editedSession.pollsEnabled}
									icons={false}
									onChange={(e) => this.editSessionField('pollsEnabled', !editedSession.pollsEnabled)}
								/>

								<ToggleField
									label="Enable Realtime 3D Effects"
									checked={editedSession.enable3dOverlays}
									icons={false}
									onChange={(e) =>
										this.editSessionField('enable3dOverlays', !editedSession.enable3dOverlays)}
								/>

								{editedSession.enable3dOverlays && (
									<ToggleField
										label="Fireworks"
										checked={editedSession.available3dOverlays && editedSession.available3dOverlays.includes('Fireworks')}
										icons={false}
										onChange={(e) => {
											const available3dOverlays = editedSession.available3dOverlays && editedSession.available3dOverlays.includes(
												'Fireworks'
											)
												? editedSession.available3dOverlays.filter((o) => o != 'Fireworks')
												: [...(editedSession.available3dOverlays || []), 'Fireworks'];
											this.editSessionField('available3dOverlays', available3dOverlays);
										}}
									/>
								)}

								{editedSession.enable3dOverlays && (
									<ToggleField
										label={'Snowfall'}
										checked={editedSession.available3dOverlays && editedSession.available3dOverlays.includes('Snow')}
										icons={false}
										onChange={(e) => {
											const available3dOverlays = editedSession.available3dOverlays && editedSession.available3dOverlays.includes(
												'Snow'
											)
												? editedSession.available3dOverlays.filter((o) => o != 'Snow')
												: [...(editedSession.available3dOverlays || []), 'Snow'];
											this.editSessionField('available3dOverlays', available3dOverlays);
										}}
									/>
								)}

								{editedSession.enable3dOverlays && (
									<ToggleField
										label={'Money Drop'}
										checked={editedSession.available3dOverlays && editedSession.available3dOverlays.includes('Money')}
										icons={false}
										onChange={(e) => {
											const available3dOverlays = editedSession.available3dOverlays && editedSession.available3dOverlays.includes(
												'Money'
											)
												? editedSession.available3dOverlays.filter((o) => o != 'Money')
												: [...(editedSession.available3dOverlays || []), 'Money'];
											this.editSessionField('available3dOverlays', available3dOverlays);
										}}
									/>
								)}
							</div>
						)}
					</div>
				</div>
				<SectionFooter editing={editing}
					cancelEdit={this.cancelEdit}
					saveEdit={this.saveInfo}
					updatedAt={session.updatedAt} />
				{DeleteSessionModalOpen && (
					<DeleteDefaultModal
						isOpen={DeleteSessionModalOpen}
						toggle={this.toggleDelete}
						title={`Delete Session`}
						message={`You are about to delete, this is irreversible,
					would you like to continue?`}
						submit={() => {
							const sessions = {};
							sessions[session._id] = true;
							this.props.deleteSession(
								sessions,
								this.props.history.push('./'),

							);
						}}
					/>
				)}
			</div>
		);
	}
}

export default withRouter(EventSession);
